"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var restful_model_1 = __importDefault(require("./restful-model"));
var attributes_1 = __importDefault(require("./attributes"));
var JobStatus = /** @class */ (function (_super) {
    __extends(JobStatus, _super);
    function JobStatus(connection, props) {
        var _this = _super.call(this, connection, props) || this;
        _this.initAttributes(props);
        return _this;
    }
    // Returns the status of a job as a boolean
    JobStatus.prototype.isSuccessful = function () {
        return this.status === 'successful';
    };
    JobStatus.collectionName = 'job-statuses';
    JobStatus.attributes = __assign(__assign({}, restful_model_1.default.attributes), { action: attributes_1.default.String({
            modelKey: 'action',
            readOnly: true,
        }), createdAt: attributes_1.default.DateTime({
            modelKey: 'createdAt',
            jsonKey: 'created_at',
            readOnly: true,
        }), jobStatusId: attributes_1.default.String({
            modelKey: 'jobStatusId',
            jsonKey: 'job_status_id',
            readOnly: true,
        }), status: attributes_1.default.String({
            modelKey: 'status',
            readOnly: true,
        }), originalData: attributes_1.default.Object({
            modelKey: 'originalData',
            jsonKey: 'original_data',
            readOnly: true,
        }) });
    return JobStatus;
}(restful_model_1.default));
exports.default = JobStatus;
